
































































































































import Vue from 'vue'
import moment from 'moment'

import {
  FindToken,
  GenerateToken,
  Token,
  RevokeToken,
  Regenerate,
} from '@/api/developer'
export default Vue.extend({
  name: 'DeveloperSetting',
  data() {
    return {
      form: {
        name: '',
        roles: '',
        expired: new Date(),
      },
      listToken: [] as Token[],
      valToken: 'misal value token',
      uid: '',
      showToken: false,
      shownToken: '',
    }
  },
  methods: {
    async getListToken() {
      this.listToken = await FindToken()
    },
    async generate() {
      const expired = moment(this.form.expired, 'YYYY-MM-DD').toDate()
      this.shownToken = await GenerateToken(
        this.form.name,
        expired,
        this.form.roles
      )
      await this.getListToken()
    },

    async revokeToken() {
      const token = await RevokeToken(this.uid)
      console.log(token)
      await this.getListToken()
    },
    async regenerateToken() {
      this.shownToken = await Regenerate(this.uid)
      this.showToken = true
    },

    onModalCancel() {
      this.uid = ''
      this.showToken = false
      this.shownToken = ''
    },

    onRenewClick(uid: string) {
      this.uid = uid
      this.$bvModal.show('modal-regenerate')
    },
    onDeleteClick(uid: string) {
      this.uid = uid
      this.$bvModal.show('modal-revoke')
    },

    onCancelCreate() {
      this.form.name = ''
      this.form.roles = ''
      this.form.expired = new Date()
      this.$bvModal.hide('modal-generate-token')
    },

    onCancelGenerate() {
      this.form.name = ''
      this.form.roles = ''
      this.form.expired = new Date()
      this.$bvModal.hide('modal-generate-token')
      this.showToken = false
      this.shownToken = ''
    },
    async onGenerate() {
      await this.generate()
      this.showToken = true
      // this.$bvModal.hide('modal-generate-token')
    },
  },
  created() {
    this.getListToken()
  },
})
